import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35dcba3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  dir: "rtl",
  class: "questionary"
}
const _hoisted_2 = { class: "questionary__wrapper" }
const _hoisted_3 = {
  id: "scroll-area",
  class: "questionary__scroll-area"
}
const _hoisted_4 = { class: "questionary__content" }
const _hoisted_5 = { class: "questionary__title" }
const _hoisted_6 = { class: "questionary__list" }

import InterviewProgress from '@/components/InterviewQuestionary/InterviewProgress.vue'
import InterviewQuestionsList from '@/components/InterviewQuestionary/InterviewQuestionsList.vue'
import { useDialog } from '@/stores/dialogStore';
import { useInterviewStore } from '@/stores/interviewStore'
import { computed, onMounted } from 'vue'
import InterviewThanks from './InterviewThanks.vue';
import DialogContainer from '../Shared/DialogContainer.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'InterviewQuestionary',
  setup(__props) {

const dialogStore = useDialog()
const interviewStore = useInterviewStore()
const interviewProgres = computed(() => interviewStore.progress)
const questions = computed(() => interviewStore.visibleQuestionsAnswer.map((q) => q.key))
const isQuestionaireFinished = computed(() => interviewStore.isThanksPageShowing);

const startInterviewText = computed(() => interviewStore.getLocalization('InterviewQuestionary.StartInterviewText'))

function onAfterEnter() {
    const closeButton = document.querySelector('.location-picker__close') as HTMLElement
    closeButton?.focus()
}

onMounted(() => {
    interviewStore.fetchQuestions();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(isQuestionaireFinished))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(InterviewProgress, {
              progress: _unref(interviewProgres),
              class: "questionary__aside"
            }, null, 8, ["progress"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(startInterviewText)), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(InterviewQuestionsList, { questions: _unref(questions) }, null, 8, ["questions"])
                  ])
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "tw-fade-top" }, {
        default: _withCtx(() => [
          (_unref(isQuestionaireFinished))
            ? (_openBlock(), _createBlock(InterviewThanks, {
                key: 0,
                thankYouPage: _unref(interviewStore).thankYouPage!
              }, null, 8, ["thankYouPage"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, {
      name: "tw-fade-down",
      onAfterEnter: onAfterEnter
    }, {
      default: _withCtx(() => [
        (_unref(dialogStore).dialogContent)
          ? (_openBlock(), _createBlock(DialogContainer, {
              key: 0,
              dir: "rtl"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})